export default "__VITE_ASSET__2e1c2710__"